const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://brexc6em9b.execute-api.us-west-2.amazonaws.com/prod',
    TEAM_API_URL: 'https://j38bdu93nf.execute-api.us-west-2.amazonaws.com/api'
  },
  reactApp: {
    VERSION: 'taxonomy-teams-1.15.5',
    HOSTNAME: 'https://teams-service.barrick.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.barrick.forwoodsafety.com',
    WEBSOCKET: 'wss://i7rfamperj.execute-api.us-west-2.amazonaws.com/prod'
  },
};

export default config;
